import React, { ReactNode } from "react";
import { Grid } from "@material-ui/core";
import { Form, Formik, FormikProps } from "formik";
import * as Yup from "yup";
import CustomDialog from "../../../../components/Dialog/CustomDialog";
import CustomTextField from "../../../../components/Input/CustomTextField";
import CustomButton from "../../../../components/Button/CustomButton";
import ManagedLaboratoryResponse from "../../../../api/models/test-request/ManagedLaboratoryResponse";
import useStyles from "./LaboratoryDialogStyles";

export interface LaboratoryDialogProps {
  open: boolean;
  laboratory: ManagedLaboratoryResponse;
  onSave: (value: object) => void;
  onClose: () => void;
}

const LaboratoryDialog: React.FC<LaboratoryDialogProps> = (props) => {
  const { open, onSave, onClose, laboratory } = props;
  const yupValidationSchema = Yup.object().shape({
    name: Yup.string().required(),
    shortName: Yup.string().required(),
  });

  const classes = useStyles();

  return (
    <CustomDialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <h2>EDIT LABORATORY NAME</h2>
      <Formik
        initialValues={{
          name: laboratory.name,
          shortName: laboratory.shortName || "",
        }}
        onSubmit={(values): void => {
          onSave(values);
        }}
        validationSchema={yupValidationSchema}
      >
        {(formikProps: FormikProps<{ name: string; shortName: string }>): ReactNode => {
          const { errors, handleBlur, handleChange, isSubmitting, touched, values } = formikProps;

          return (
            <Form>
              <Grid container direction="column" spacing={3}>
                <Grid item>
                  <CustomTextField
                    className={classes.input}
                    autoFocus
                    fullWidth
                    name="name"
                    id="name"
                    label="New laboratory name"
                    value={values.name}
                    helperText={[errors.name && touched.name ? errors.name : ""].join(" ")}
                    error={!!(errors.name && touched.name)}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <CustomTextField
                    className={classes.input}
                    fullWidth
                    name="shortName"
                    id="shortName"
                    label="New laboratory short name"
                    value={values.shortName}
                    helperText={[errors.shortName && touched.shortName ? errors.shortName : ""].join(" ")}
                    error={!!(errors.shortName && touched.shortName)}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </Grid>
                <Grid container item direction="row" justify="flex-end">
                  <CustomButton disabled={isSubmitting} primary text="Save" type="submit" />
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </CustomDialog>
  );
};

export default LaboratoryDialog;
